import { Property } from '../../../../../models/Property';
import BulletList, { checkForBulletPoints } from '../../bullet-list/BulletList';

interface OverviewDescriptionProps {
  property: Property;
}
export default function OverviewDescription({ property }: OverviewDescriptionProps) {
  return (
    <div className="overview-description">
      <h4>Description</h4>
      {(checkForBulletPoints(property.siteBuildingDescription) && property.siteBuildingDescription)
        ? <BulletList description={property.siteBuildingDescription} />
        : <p>{property.siteBuildingDescription}</p>
      }
    </div>
  );
}
